import React from 'react';
import Loader from '../components/loader';
// import HeroAbout from '../components/HeroAbout';
import HeroHeader from '../components/HeroHeader';
import Activities from '../components/Activities';
import MainAbout from '../components/MainAbout';
import MetaTags from '../common-components/MetaTags';

class AboutPage extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: true,
    };
  }

  componentDidMount() {
    // document.title = "About Us - Learn Quran Easily";
    // document.description = "Learn Quran Easily"
    setTimeout(() => {
      this.setState({ loading: false });
    }, 1000); // Simulate a 3-second loading delay
  }


  render() {
    const aboutData = {
      aboutTitle: {
        text: "About THEMosque",
        images: [
          { src: "img/about-1.jpg", alt: "About Image 1", class: "h-100" },
          { src: "img/about-2.jpg", alt: "About Image 2", class: "h-100" },
          // { src: "img/about-3.jpg", alt: "About Image 3", class: "pb-3" }
        ]
      },
      bannerText: "Allah Help Those Who Help Themselves",
      visionText: "Lorem ipsum dolor sit amet elit. Donec tempus eros vel dolor mattis aliquam. Etiam quis mauris justo.",
      missionText: "Lorem ipsum dolor sit amet tetur nod elit sed.",
      childImage: {
        src: "img/about-child.jpg",
        alt: "About Child",
        description: "Lorem ipsum dolor sit amet elit. Donec tempus eros vel dolor mattis aliquam."
      },
      raisedAmount: "20,46",
      services: [
        "Charity & Donation",
        "Parent Education",
        "Hadith & Sunnah",
        "Mosque Development"
      ],
      additionalBannerText: "Every Muslim Needs To Realise The Importance Of The 'Pillar' Of Islam",
      buttonText: "Learn More"
    };

    // const teamData = [
    //   {
    //     image: "img/team-1.jpg",
    //     name: "Anamul Hasan",
    //     role: "President",
    //     description: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
    //     socialLinks: [
    //       { icon: "fab fa-facebook-f", url: "#" },
    //       { icon: "fab fa-twitter", url: "#" },
    //       { icon: "fab fa-instagram", url: "#" },
    //       { icon: "fab fa-linkedin-in", url: "#" },
    //     ],
    //     sizeLg: 4,
    //     sizeXl: 5
    //   },
    //   {
    //     image: "img/team-2.jpg",
    //     name: "Mustafa Kamal",
    //     role: "Imam",
    //     description: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
    //     socialLinks: [
    //       { icon: "fab fa-facebook-f", url: "#" },
    //       { icon: "fab fa-twitter", url: "#" },
    //       { icon: "fab fa-instagram", url: "#" },
    //       { icon: "fab fa-linkedin-in", url: "#" },
    //     ],
    //     sizeLg: 4,
    //     sizeXl: 4
    //   },
    //   {
    //     image: "img/team-3.jpg",
    //     name: "Nahiyan Momen",
    //     role: "Teacher",
    //     description: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
    //     socialLinks: [
    //       { icon: "fab fa-facebook-f", url: "#" },
    //       { icon: "fab fa-twitter", url: "#" },
    //       { icon: "fab fa-instagram", url: "#" },
    //       { icon: "fab fa-linkedin-in", url: "#" },
    //     ],
    //     sizeLg: 4,
    //     sizeXl: 4
    //   },
    //   {
    //     image: "img/team-4.jpg",
    //     name: "Asfaque Ali",
    //     role: "Volunteer",
    //     description: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
    //     socialLinks: [
    //       { icon: "fab fa-facebook-f", url: "#" },
    //       { icon: "fab fa-twitter", url: "#" },
    //       { icon: "fab fa-instagram", url: "#" },
    //       { icon: "fab fa-linkedin-in", url: "#" },
    //     ],
    //     sizeLg: 4,
    //     sizeXl: 4
    //   }
    // ];
    const breadcrumbs = [
        { label: 'Home', href: '#', isCurrentPage: false },
        { label: 'Pages', href: '#', isCurrentPage: false },
        { label: 'About', href: '#', isCurrentPage: true },
      ];

    return <>
   <MetaTags
      title="About Us - Learn Quran Easily"
      description="Discover the vision, mission, and people behind Learn Quran Easily. We are committed to spreading authentic Islamic knowledge through quality online education."
      keywords="About Learn Quran Easily, Online Quran Learning, Islamic Education, LQE Team, Mission and Vision, Quran Classes"
      author="Learn Quran Easily Team"
      url="https://learnquraneasily.in/about"
      image="https://lqe-assets.learnquraneasily.in/1747284949484_Lqe_logo.png"
    />
      {this.state.loading ? <Loader /> :
        <>
          <HeroHeader  title="About Us" breadcrumbs={breadcrumbs} />
          <MainAbout {...aboutData} />
          <Activities />
        </>}
    </>
  }
}

export default AboutPage;
